import { AdvizedCategory, AdvizedExpert } from '../../types';

import { MetaDataContext } from './types';

type Props = {
  data: {
    expert: AdvizedExpert;
  };
};

const expertProfile = ({ data }: Props, { t }: MetaDataContext) => {
  if (!data) {
    return {};
  }

  const { expert } = data;

  if (!expert) return {};

  const getCategoriesString = (categories: AdvizedCategory[]) => {
    if (categories.length === 1) {
      return categories[0].name.toLowerCase();
    }
    if (categories.length === 2) {
      return t('meta', 'expert.profile-description-categories-multiple', {
        category1: categories[0].name.toLowerCase(),
        category2: categories[1].name.toLowerCase(),
      });
    }
    if (categories.length === 3) {
      return `${categories[0].name.toLowerCase()}, ${t(
        'meta',
        'expert.profile-description-categories-multiple',
        {
          category1: categories[1].name.toLowerCase(),
          category2: categories[2].name.toLowerCase(),
        }
      )}`;
    }
    if (categories.length > 3) {
      return categories.map(category => category.name).join(', ');
    }
    return '';
  };

  const firstname = expert.name.split(' ')[0];

  const title = t('meta', 'expert.profile-title', {
    name: expert.name,
  });

  const description = t('meta', 'expert.profile-description', {
    categories: expert.categories?.length
      ? t('meta', 'expert.profile-description-categories', {
          categories: getCategoriesString(expert.categories),
        })
      : '',
    fullname: expert.name,
    firstname:
      firstname[firstname.length - 1] === 's' ? firstname : `${firstname}s`,
  });

  return {
    title,
    description,
    canonical: expert.fullUrl,
    openGraph: [
      { key: 'url', content: expert.fullUrl },
      { key: 'title', content: title },
      { key: 'description', content: description },
      { key: 'type', content: 'website' },
      { key: 'siteName', content: t('meta', 'site.name') },
    ],
    structuredData: undefined,
  };
};

export default expertProfile;
